module.exports = __webpack_public_path__ + "static/elite-concrete-e032658693d102c20324275b1bcf3553.png";